import { ApiCollectionInterface } from '../model/api-collection.interface';
import { ApiInterface } from '../model/api.interface';

/**
 * Transforms api data into relationships from includes
 *
 * __Example :__
 *   this.http.get('/endpoint?&include=pitch,staffMember')
 *   .map(data => this.transformer.mapOneInCollection(data, [{ pitch: 'pitches' }, { staffMember: 'staff-members' }]))
 *
 */
export class TransformApiData {

    mapOne(apiData: ApiInterface, relationshipToType: Array<{ [key: string]: string }>): ApiInterface {
        relationshipToType.forEach(relationshipKeyValue => {
            Object.keys(relationshipKeyValue).forEach(relKeyName => {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.included.forEach(includedData => {
                        if (
                            apiData.data.relationships[relKeyName].data &&
                            apiData.data.relationships[relKeyName].data.id === includedData.id &&
                            includedData.type === relationshipKeyValue[relKeyName]) {
                            apiData.data.relationships[relKeyName].data = includedData;
                        }
                    });
                }
            });
        });

        return apiData;
    }

    mapArray(apiData: ApiInterface, relationshipToType: Array<{ [key: string]: string }>): ApiInterface {
        relationshipToType.forEach(relationshipKeyValue => {
            Object.keys(relationshipKeyValue).forEach(relKeyName => {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.data.relationships[relKeyName].data.forEach((relationshipKey, key) => {

                        apiData.included.forEach(includedData => {
                            if (
                                apiData.data.relationships[relKeyName].data[key] &&
                                apiData.data.relationships[relKeyName].data[key].id === includedData.id &&
                                includedData.type === relationshipKeyValue[relKeyName]) {
                                apiData.data.relationships[relKeyName].data[key] = includedData;
                            }
                        });
                    });
                }
            });
        });

        return apiData;
    }

    mapOneInCollection(apiData: ApiCollectionInterface, relationshipToType: Array<{ [key: string]: string }>): ApiCollectionInterface {
        relationshipToType.forEach(relationshipKeyValue => {
            Object.keys(relationshipKeyValue).forEach(relKeyName => {
                if (apiData.included && apiData.included.length > 0) {
                    apiData.data.forEach(entity => {
                        apiData.included.forEach(includedData => {
                            if (
                                entity.relationships[relKeyName].data &&
                                entity.relationships[relKeyName].data.id === includedData.id &&
                                includedData.type === relationshipKeyValue[relKeyName]) {
                                entity.relationships[relKeyName].data = includedData;
                            }
                        });
                    });
                }
            });
        });

        return apiData;
    }

    mapArrayInCollection(apiData: ApiCollectionInterface, relationshipToType: Array<{ [key: string]: string }>): ApiCollectionInterface {
        relationshipToType.forEach(relationshipKeyValue => {
            Object.keys(relationshipKeyValue).forEach(relKeyName => {

                if (apiData.included && apiData.included.length > 0) {
                    apiData.data.forEach(entity => {
                        entity.relationships[relKeyName].data.forEach((relationshipKey, key) => {

                            apiData.included.forEach(includedData => {
                                if (
                                    entity.relationships[relKeyName].data[key] &&
                                    entity.relationships[relKeyName].data[key].id === includedData.id &&
                                    includedData.type === relationshipKeyValue[relKeyName]) {
                                    entity.relationships[relKeyName].data[key] = includedData;
                                }
                            });
                        });
                    });
                }
            });
        });

        return apiData;
    }
}
